import { useState } from 'react';
import {
  FaEnvelope,
  FaMapMarkerAlt,
  FaPaperPlane,
  FaUser,
  FaComment,
} from 'react-icons/fa';
import './Contact.css';
import emailjs from 'emailjs-com';
import { toast } from 'react-toastify';

const toastStyle = {
  background: 'rgba(120, 255, 255, 0.02)',
  color: '#fff',
};

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [buttonDisable, setButtonDisable] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (buttonDisable) return;

    emailjs
      .sendForm(
        process.env.REACT_APP_SERVICE_KEY,
        process.env.REACT_APP_TEMPLATE_KEY,
        e.target,
        process.env.REACT_APP_PUBLIC_KEY
      )
      .then(
        (result) => {
          toast.success('📨 Your message has been sent to Skand Sisodia! 🚀', {
            style: toastStyle,
          });
        },
        (error) => {
          toast.error(
            '😲 Oops! Something went wrong while sending your message. Please try again later. 💌',
            { style: toastStyle }
          );
        }
      )
      .finally(() => {
        setButtonDisable(true);
      });

    setFormData({ name: '', email: '', subject: '', message: '' });
    setTimeout(() => {
      setButtonDisable(false);
    }, 30 * 10000);
  };

  const contactInfo = [
    {
      icon: <FaEnvelope />,
      title: 'Email',
      value: 'sisodiaskand@gmail.com',
      link: 'mailto:sisodiaskand@gmail.com',
    },
    {
      icon: <FaMapMarkerAlt />,
      title: 'Location',
      value: 'Ghaziabad, Uttar Pradesh, India',
      link: null,
    },
  ];

  return (
    <section id='contact' className='contact'>
      <div className='container'>
        <h2 className='section-title'>Get In Touch</h2>

        <div className='contact-content'>
          <div className='contact-info-section'>
            <h3>Let's Connect</h3>
            <p className='contact-description'>
              I'm always interested in hearing about new opportunities and
              exciting projects. Whether you have a question or just want to say
              hi, feel free to reach out!
            </p>

            <div className='contact-info-list'>
              {contactInfo.map((info, index) => (
                <div key={index} className='contact-info-item'>
                  <div className='contact-icon'>{info.icon}</div>
                  <div className='contact-details'>
                    <h4>{info.title}</h4>
                    {info.link ? (
                      <a
                        href={info.link}
                        target={
                          info.link.startsWith('mailto:') ||
                          info.link.startsWith('tel:')
                            ? '_self'
                            : '_blank'
                        }
                        rel='noopener noreferrer'
                      >
                        {info.value}
                      </a>
                    ) : (
                      <span>{info.value}</span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className='contact-form-section'>
            <form className='contact-form' onSubmit={handleSubmit}>
              <div className='form-group'>
                <div className='input-icon'>
                  <FaUser className='icon' />
                  <input
                    type='text'
                    name='name'
                    placeholder='Your Name'
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className='form-group'>
                <div className='input-icon'>
                  <FaEnvelope className='icon' />
                  <input
                    type='email'
                    name='email'
                    placeholder='Your Email'
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className='form-group'>
                <div className='input-icon'>
                  <FaComment className='icon' />
                  <input
                    type='text'
                    name='subject'
                    placeholder='Subject'
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className='form-group'>
                <div className='input-icon'>
                  <FaComment className='icon' />
                  <textarea
                    name='message'
                    placeholder='Your Message'
                    value={formData.message}
                    onChange={handleChange}
                    rows='5'
                    required
                  ></textarea>
                </div>
              </div>

              <button type='submit' className='submit-btn'>
                <FaPaperPlane className='icon' />
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
